import { css } from 'styled-components';
import { colorsV2 } from '../../colors-v2';

const blackStyles = css`
  &.black {
    background-color: ${colorsV2.neutral180};
    color: ${colorsV2.white100};

    &:hover {
      background-color: ${colorsV2.neutral160};
      color: ${colorsV2.white100};
    }

    &:active,
    &:focus {
      background-color: ${colorsV2.neutral140};
      color: ${colorsV2.white100};
    }

    &.disabled {
      background-color: ${colorsV2.neutral10};
      color: ${colorsV2.neutral60};
    }

    &.transparent {
      background-color: transparent;
      color: ${colorsV2.neutral180};

      &:hover {
        background-color: ${colorsV2.neutral10};
        color: ${colorsV2.neutral180};
      }

      &:active,
      &:focus {
        background-color: ${colorsV2.neutral20};
        color: ${colorsV2.neutral180};
      }

      &.disabled {
        background-color: transparent;
        color: ${colorsV2.neutral60};
      }
    }
  }
`;

const greenStyles = css`
  &.green {
    background-color: ${colorsV2.green10};
    color: ${colorsV2.green100};

    &:hover {
      background-color: ${colorsV2.green20};
      color: ${colorsV2.green100};
    }

    &:active,
    &:focus {
      background-color: ${colorsV2.green40};
      color: ${colorsV2.green100};
    }

    &.disabled {
      background-color: ${colorsV2.neutral10};
      color: ${colorsV2.neutral60};
    }

    &.transparent {
      background-color: transparent;

      &:hover {
        background-color: ${colorsV2.green20};
        color: ${colorsV2.green100};
      }

      &:active,
      &:focus {
        background-color: ${colorsV2.green40};
        color: ${colorsV2.green100};
      }

      &.disabled {
        background-color: transparent;
        color: ${colorsV2.neutral60};
      }
    }
  }
`;

const redStyles = css`
  &.red {
    background-color: ${colorsV2.red10};
    color: ${colorsV2.red100};

    &:hover {
      background-color: ${colorsV2.red20};
      color: ${colorsV2.red100};
    }

    &:active,
    &:focus {
      background-color: ${colorsV2.red40};
      color: ${colorsV2.red100};
    }

    &.disabled {
      background-color: ${colorsV2.neutral10};
      color: ${colorsV2.neutral60};
    }

    &.transparent {
      background-color: transparent;

      &:hover {
        background-color: ${colorsV2.red20};
        color: ${colorsV2.red100};
      }

      &:active,
      &:focus {
        background-color: ${colorsV2.red40};
        color: ${colorsV2.red100};
      }

      &.disabled {
        background-color: transparent;
        color: ${colorsV2.neutral60};
      }
    }
  }
`;

const blueStyles = css`
  &.blue {
    background-color: ${colorsV2.blue10};
    color: ${colorsV2.blue100};

    &:hover {
      background-color: ${colorsV2.blue20};
      color: ${colorsV2.blue100};
    }

    &:active,
    &:focus {
      background-color: ${colorsV2.blue40};
      color: ${colorsV2.blue100};
    }

    &.disabled {
      background-color: ${colorsV2.neutral10};
      color: ${colorsV2.neutral60};
    }

    &.transparent {
      background-color: transparent;

      &:hover {
        background-color: ${colorsV2.blue20};
        color: ${colorsV2.blue100};
      }

      &:active,
      &:focus {
        background-color: ${colorsV2.blue40};
        color: ${colorsV2.blue100};
      }

      &.disabled {
        background-color: transparent;
        color: ${colorsV2.neutral60};
      }
    }
  }
`;

const yellowStyles = css`
  &.yellow {
    background-color: ${colorsV2.yellow10};
    color: ${colorsV2.yellow100};

    &:hover {
      background-color: ${colorsV2.yellow20};
      color: ${colorsV2.yellow100};
    }

    &:active,
    &:focus {
      background-color: ${colorsV2.yellow40};
      color: ${colorsV2.yellow100};
    }

    &.disabled {
      background-color: ${colorsV2.neutral10};
      color: ${colorsV2.neutral60};
    }

    &.transparent {
      background-color: transparent;

      &:hover {
        background-color: ${colorsV2.yellow20};
        color: ${colorsV2.yellow100};
      }

      &:active,
      &:focus {
        background-color: ${colorsV2.yellow40};
        color: ${colorsV2.yellow100};
      }

      &.disabled {
        background-color: transparent;
        color: ${colorsV2.neutral60};
      }
    }
  }
`;

const whiteStyles = css`
  &.white {
    background-color: ${colorsV2.white100};
    color: ${colorsV2.neutral100};

    &:hover {
      background-color: ${colorsV2.white60};
      color: ${colorsV2.neutral100};
    }

    &:active,
    &:focus {
      background-color: ${colorsV2.white100};
      color: ${colorsV2.neutral100};
    }

    &.disabled {
      background-color: ${colorsV2.neutral10};
      color: ${colorsV2.neutral60};
    }

    &.transparent {
      background-color: transparent;

      &:hover {
        background-color: ${colorsV2.white60};
        color: ${colorsV2.neutral100};
      }

      &:active,
      &:focus {
        background-color: ${colorsV2.white100};
        color: ${colorsV2.neutral100};
      }

      &.disabled {
        background-color: transparent;
        color: ${colorsV2.neutral60};
      }
    }
  }
`;

const gray4Styles = css`
  &.gray4 {
    background-color: ${colorsV2.white100};
    color: ${colorsV2.neutral140};

    &:hover {
      background-color: ${colorsV2.neutral10};
      color: ${colorsV2.neutral140};
    }

    &:active,
    &:focus {
      background-color: ${colorsV2.neutral20};
      color: ${colorsV2.neutral140};
    }

    &.disabled {
      background-color: ${colorsV2.neutral10};
      color: ${colorsV2.neutral60};
    }

    &.transparent {
      background-color: transparent;

      &:hover {
        background-color: ${colorsV2.neutral10};
        color: ${colorsV2.neutral140};
      }

      &:active,
      &:focus {
        background-color: ${colorsV2.neutral20};
        color: ${colorsV2.neutral140};
      }

      &.disabled {
        background-color: transparent;
        color: ${colorsV2.neutral60};
      }
    }
  }
`;

const gray3Styles = css`
  &.gray3 {
    background-color: ${colorsV2.neutral20};
    color: ${colorsV2.neutral100};

    &:hover {
      background-color: ${colorsV2.neutral40};
      color: ${colorsV2.neutral100};
    }

    &:active,
    &:focus {
      background-color: ${colorsV2.neutral60};
      color: ${colorsV2.neutral100};
    }

    &.disabled {
      background-color: ${colorsV2.neutral10};
      color: ${colorsV2.neutral60};
    }

    &.transparent {
      background-color: transparent;

      &:hover {
        background-color: ${colorsV2.neutral40};
        color: ${colorsV2.neutral100};
      }

      &:active,
      &:focus {
        background-color: ${colorsV2.neutral60};
        color: ${colorsV2.neutral100};
      }

      &.disabled {
        background-color: transparent;
        color: ${colorsV2.neutral60};
      }
    }
  }
`;

const gray2Styles = css`
  &.gray2 {
    background-color: ${colorsV2.neutral10};
    color: ${colorsV2.neutral100};

    &:hover {
      background-color: ${colorsV2.neutral20};
      color: ${colorsV2.neutral100};
    }

    &:active,
    &:focus {
      background-color: ${colorsV2.neutral40};
      color: ${colorsV2.neutral100};
    }

    &.disabled {
      background-color: ${colorsV2.neutral10};
      color: ${colorsV2.neutral60};
    }

    &.transparent {
      background-color: transparent;

      &:hover {
        background-color: ${colorsV2.neutral20};
        color: ${colorsV2.neutral100};
      }

      &:active,
      &:focus {
        background-color: ${colorsV2.neutral40};
        color: ${colorsV2.neutral100};
      }

      &.disabled {
        background-color: transparent;
        color: ${colorsV2.neutral60};
      }
    }
  }
`;

const gray1Styles = css`
  &.gray1 {
    background-color: ${colorsV2.white100};
    color: ${colorsV2.neutral100};

    &:hover {
      background-color: ${colorsV2.neutral10};
      color: ${colorsV2.neutral100};
    }

    &:active,
    &:focus {
      background-color: ${colorsV2.neutral20};
      color: ${colorsV2.neutral100};
    }

    &.disabled {
      background-color: ${colorsV2.neutral10};
      color: ${colorsV2.neutral60};
    }

    &.transparent {
      background-color: transparent;

      &:hover {
        background-color: ${colorsV2.neutral10};
        color: ${colorsV2.neutral100};
      }

      &:active,
      &:focus {
        background-color: ${colorsV2.neutral20};
        color: ${colorsV2.neutral100};
      }

      &.disabled {
        background-color: transparent;
        color: ${colorsV2.neutral60};
      }
    }
  }
`;

export const colorStyles = css`
  ${gray1Styles}
  ${gray2Styles}
  ${gray3Styles}
  ${gray4Styles}
  ${whiteStyles}
  ${yellowStyles}
  ${blueStyles}
  ${redStyles}
  ${greenStyles}
  ${blackStyles}
`;
